/**
 * The LoginError Code.
 */
export type LoginErrorCode = 'wrongUsername' | 'wrongPassword' | 'multiFactorAuth' | 'unknown';

/**
 * Error thrown when the login is not performed successfully
 *
 * @export
 */
export class LoginError implements Error {
    /** The Error Name */
    get name(): string {
        return 'LoginError';
    }

    /** The Error Message */
    message: string;

    /** The Error Code */
    code: LoginErrorCode;

    /** the phone-number available in multi-factor authentication errors */
    phoneNumber: string;

    constructor(code: LoginErrorCode, message: string, phoneNumber?: string) {
        this.message = message;
        this.code = code;
        this.phoneNumber = phoneNumber;
    }
}
